import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import SelectColumn from './table/SelectColumn'
import DateColumn from './table/DateColumn'

class Scadenze extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: true, isEditable: true, isDeletable: true },
        columns: {
          idazi: { onInsertDisabled: true }
        }
      },
      'ADM': {
        action: { isImpersonate: false, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {
          idazi: { onInsertDisabled: true }
        }
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true),
      Mapper.column.ambito()
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new SelectColumn('idazi', Mapper.select.azienda()).withType('number').withIsEditable(true).withOnEditDisabled(true).withIsInsertable(true),
      new Column('id').withLabel('column.id').withField('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new SelectColumn('ambito', Mapper.select.ambito()).withType('text').withIsVisible(false).withOnEditDisabled(true).withOnInsertDisabled(true),
      new DateColumn('datains'),
      new SelectColumn('tiposca', Mapper.select.tipoScadenze()).withType('number').withUpdateOnChange(['tiprec']),
      new Column('oggetto').withType('text'),
      new DateColumn('datasca'),
      new Column('preavvisogg').withType('text'),
      new DateColumn('datachiu'),
      new Column('idnuovascad').withType('text'),
      new Column('notificata').withType('text'),
      new Column('esito').withType('text'),
      new Column('rinnovo_automatico').withType('text'),
      new Column('mesi_rinnovo').withType('text')
    ]
  }

  validator () {
    return {
      idazi: { required: true, type: 'number' },
      ambito: { required: true, type: 'string' },
      dexdpi: { required: true, type: 'string' },
      marcamodello: { required: true, type: 'string' },
      mansione: { required: true, type: 'string' },
      fattore: { required: true, type: 'string' }
    }
  }
}

export default new Scadenze()
